import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
let NoDeviceId = class NoDeviceId extends Vue {
    noUrl = require('@blade/common/assets/images/no-data/empty-img-gray.png');
};
NoDeviceId = __decorate([
    Component({
        name: 'NoDeviceId',
        components: {},
        i18n: {
            messages: {
                en: {
                    pleaseTip: 'please select a camera'
                },
                zh: {
                    pleaseTip: '请选择一个设备'
                }
            }
        }
    })
], NoDeviceId);
export default NoDeviceId;
